"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const native_1 = require("@react-navigation/native");
const react_redux_1 = require("react-redux");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const clipboard_1 = __importDefault(require("@react-native-clipboard/clipboard"));
const yet_another_react_lightbox_1 = __importDefault(require("yet-another-react-lightbox"));
const fullscreen_1 = __importDefault(require("yet-another-react-lightbox/plugins/fullscreen"));
const thumbnails_1 = __importDefault(require("yet-another-react-lightbox/plugins/thumbnails"));
const zoom_1 = __importDefault(require("yet-another-react-lightbox/plugins/zoom"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const user_1 = require("../../store/selectors/user");
const document_1 = require("../../store/selectors/document");
const store_1 = require("../../store");
const user_2 = require("../../slices/user");
const conversation_1 = require("../../slices/conversation");
const useDevice_1 = require("../../hooks/useDevice");
const useAppMessage_1 = require("../../hooks/useAppMessage");
const useConversations_1 = require("../../hooks/useConversations");
const useChatMessages_1 = require("../../hooks/useChatMessages");
const VoiceMessage_1 = __importDefault(require("./VoiceMessage"));
const MessageWarn_1 = __importDefault(require("../../component/MessageWarn"));
const ChatText_1 = __importDefault(require("../../component/Chat/ChatText"));
const ChatImage_1 = __importDefault(require("../../component/Chat/ChatImage"));
const ChatFile_1 = __importDefault(require("../../component/Chat/ChatFile"));
const ChatStreamingText_1 = __importDefault(require("../../component/Chat/ChatStreamingText"));
const ReadLoud_1 = __importDefault(require("../../component/ReadLoud"));
const VStack_1 = __importDefault(require("../../component/ui-components/VStack"));
const AppTooltip_1 = __importDefault(require("../../component/AppTooltip"));
const AppText_1 = require("../../component/AppText");
const utils_1 = require("../../helper/utils");
const chat_1 = require("../../helper/chat");
const document_2 = require("../../helper/document");
const theme_1 = require("../../helper/theme");
const colors_1 = require("../../common/colors");
const character_1 = require("../../services/character");
const error_1 = require("../../common/error");
const useAppQuota_1 = require("../../hooks/useAppQuota");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const counter_1 = __importDefault(require("yet-another-react-lightbox/plugins/counter"));
const ChatMessages = ({ conversation }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { showNotification } = (0, useAppMessage_1.useAppMessage)();
    const isFocused = (0, native_1.useIsFocused)();
    const { isTabOrDesktopDevice, isWebDevice, isMobileScreen, } = (0, useDevice_1.useDevice)();
    const insets = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const { sendInitialConversationMessege } = (0, useConversations_1.useConversations)();
    const { sendMessageAsStream } = (0, useChatMessages_1.useChatMessages)();
    const { pendingMessageCount } = (0, useAppQuota_1.useAppQuota)();
    const character = (0, react_redux_1.useSelector)(user_1.selectCharacterProfile);
    const storedMessages = (0, react_redux_1.useSelector)((state) => state.getUserOptions.storedMessages);
    const documentJson = (0, react_redux_1.useSelector)(document_1.selectDocumentJson);
    const chatAction = (0, react_redux_1.useSelector)((state) => state.getUserOptions.chatAction);
    const isCharacterTyping = (0, react_redux_1.useSelector)(user_1.selectIsCharacterTyping);
    const isImageLoading = (0, react_redux_1.useSelector)((state) => state.getUserOptions.isImageLoading);
    const generatedImageId = (0, react_redux_1.useSelector)((state) => state.getUserOptions.generatedImageId);
    const refreshMessages = (0, react_redux_1.useSelector)((state) => state.getUserOptions.refreshMessages);
    const isMsgBox = (0, react_redux_1.useSelector)((state) => state.getSearchInputFlag.isMsgBox);
    const userName = (0, react_redux_1.useSelector)(user_1.selectDisplayName);
    const autoSentMessage = (0, react_redux_1.useSelector)(user_1.selectAutoSentMessage);
    const autoPlay = (0, react_redux_1.useSelector)(conversation_1.selectAutoPlay);
    const [audioMessage, setAudioMessage] = (0, react_1.useState)();
    const [activeMessage, setActiveMessage] = (0, react_1.useState)(-1);
    const [isPlaying, setIsPlaying] = (0, react_1.useState)(false);
    const [isAudioPlaying, setIsAudioPlaying] = (0, react_1.useState)(false);
    const [isUserScrolling, setIsUserScrolling] = (0, react_1.useState)(false);
    const [isSheetOpen, setIsSheetOpen] = (0, react_1.useState)(false);
    const [oldChatStyle, setOldChatStyle] = (0, react_1.useState)();
    const [isViewingImage, setIsViewingImage] = (0, react_1.useState)(false);
    const [viewingImageUrl, setViewingImageUrl] = (0, react_1.useState)('');
    const messagesRef = (0, react_1.useRef)();
    const oldConversation = (0, react_1.useRef)();
    const newMessageControl = (0, react_1.useRef)(false);
    const lastScrollPosition = (0, react_1.useRef)(0);
    const scrollRef = (0, react_1.useRef)(null);
    const [userFirstName, userLastName] = (0, react_1.useMemo)(() => (userName ? userName.split(' ') : ['', '']), [userName]);
    const msgsMemo = (0, react_1.useMemo)(() => {
        messagesRef.current = isFocused && storedMessages || [];
        return messagesRef.current;
    }, [isFocused, storedMessages]);
    const lastMessage = (0, react_1.useMemo)(() => {
        const lastIndex = msgsMemo.length - 1;
        if (msgsMemo.length && msgsMemo[lastIndex].sender === 'assistant') {
            return msgsMemo[lastIndex];
        }
        else {
            return msgsMemo[lastIndex - 1];
        }
    }, [msgsMemo]);
    const messageImages = (0, react_1.useMemo)(() => (msgsMemo.reduce((medias, message) => ([
        ...medias,
        ...(message.filesSource || message.mediaUrls).filter((mediaSource) => (!(0, chat_1.checkIsFile)(typeof mediaSource === 'string' ? mediaSource : mediaSource.name))).map((mediaSource) => typeof mediaSource === 'string' ? mediaSource : mediaSource.url)
    ]), [])), [msgsMemo]);
    const viewingImageIndex = (0, react_1.useMemo)(() => (messageImages.findIndex((image) => image === viewingImageUrl)), [viewingImageUrl, messageImages]);
    const getConversations = (0, react_1.useCallback)(async () => {
        dispatch((0, user_2.setStoredMessages)([]));
        if (conversation.id) {
            if (conversation.lastMessageId) {
                const messages = await (0, character_1.getConversationMessages)(conversation.id);
                if (messages instanceof error_1.APIError) {
                    showNotification('Error', messages.message, 'error');
                }
                else if (messages instanceof error_1.RequestError) {
                    showNotification('Error', 'Oops! An error occured on this conversation', 'error');
                }
                else {
                    dispatch((0, user_2.setStoredMessages)((0, utils_1.sortedConversations)(messages.data)));
                }
            }
            if (autoSentMessage) {
                autoSentMessage && sendMessageAsStream({ message: autoSentMessage });
                dispatch((0, user_2.resetAutoSentMessage)());
            }
        }
    }, [
        dispatch,
        character,
        conversation,
        pendingMessageCount,
        autoSentMessage,
        sendMessageAsStream,
    ]);
    const getMessageIndex = (0, react_1.useCallback)((id) => msgsMemo?.findIndex((msg) => msg.id === id), [msgsMemo]);
    const scrollToMessage = (0, react_1.useCallback)((id) => {
        const msgIndex = msgsMemo?.findIndex((msg) => msg.id === id);
        if (msgIndex >= 0) {
            scrollRef?.current?.scrollToIndex({
                index: msgIndex,
                viewPosition: 0.5,
            });
        }
        if (id === "-1") {
            scrollRef?.current?.scrollToIndex({
                index: msgsMemo.length - 1,
                viewPosition: 1,
            });
        }
    }, [msgsMemo]);
    (0, react_1.useEffect)(() => {
        const fetchMessages = async () => {
            if (isFocused) {
                if (character.id.toString() !== conversation.participantId) {
                    dispatch((0, user_2.setStoredMessages)([]));
                }
                else if (conversation.id !== oldConversation.current?.id) {
                    oldConversation.current = conversation;
                    await getConversations();
                }
                else if (autoSentMessage) {
                    sendMessageAsStream({ message: autoSentMessage });
                    dispatch((0, user_2.resetAutoSentMessage)());
                }
            }
        };
        fetchMessages();
    }, [
        isFocused,
        character,
        conversation,
        autoSentMessage,
        sendMessageAsStream,
        getConversations,
        dispatch,
    ]);
    (0, react_1.useEffect)(() => {
        if (newMessageControl.current && lastMessage) {
            newMessageControl.current = false;
            autoPlay && setIsAudioPlaying(true);
        }
        ;
    }, [lastMessage, autoPlay]);
    (0, react_1.useEffect)(() => {
        if (isCharacterTyping) {
            setIsUserScrolling(false);
            newMessageControl.current = true;
        }
    }, [isCharacterTyping]);
    (0, react_1.useEffect)(() => {
        if (generatedImageId && isImageLoading) {
            scrollToMessage(generatedImageId);
        }
    }, [generatedImageId, isImageLoading, scrollToMessage]);
    (0, react_1.useEffect)(() => {
        if (autoPlay && !lastMessage?.isMedia) {
            setAudioMessage(lastMessage);
        }
        ;
    }, [autoPlay, lastMessage]);
    (0, react_1.useEffect)(() => {
        return () => { dispatch((0, user_2.setImageLoading)(false)); };
    }, []);
    (0, react_1.useEffect)(() => {
        if (isFocused && refreshMessages) {
            dispatch((0, user_2.setImageLoading)(false));
            dispatch((0, user_2.setRefreshMessages)(false));
            setTimeout(() => {
                getConversations();
            }, 200);
        }
    }, [isFocused, refreshMessages, getConversations]);
    const handleCopyText = (0, react_1.useCallback)((text) => {
        clipboard_1.default.setString(text);
        showNotification("Copied", "", "success", 2500);
    }, []);
    const handlePressImage = (0, react_1.useCallback)((source) => {
        setIsViewingImage(true);
        setViewingImageUrl(source);
    }, []);
    const handleReadAloud = (0, react_1.useCallback)((message) => {
        setAudioMessage(message);
        setIsAudioPlaying(true);
    }, []);
    const handleClosePlayer = (0, react_1.useCallback)(() => {
        setIsAudioPlaying(false);
    }, []);
    const StreamBox = (0, react_1.useCallback)(() => ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(VStack_1.default, { children: (0, jsx_runtime_1.jsx)(ChatStreamingText_1.default, { isStreaming: true }) }) })), [conversation]);
    const UserImage = (0, react_1.useCallback)(({ source }) => ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: () => handlePressImage(source), children: (0, jsx_runtime_1.jsx)(ChatImage_1.default, { source: source }) })), [handlePressImage]);
    const renderItem = (0, react_1.useCallback)(({ item, index }) => {
        const chatMsg = item;
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(native_base_1.Box, { children: [chatMsg.sender === "user" && ((0, jsx_runtime_1.jsxs)(VStack_1.default, { children: [(0, jsx_runtime_1.jsxs)(native_base_1.HStack, { space: 4, marginTop: 0.5, children: [(0, jsx_runtime_1.jsx)(native_base_1.Avatar, { size: 7, bg: colors_1.Colors.PRIMARY_100, children: (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.PRIMARY_700, fontSize: 12, fontWeight: 500, children: userFirstName[0]
                                                ? `${userFirstName[0] || ''}${userLastName?.[0] || ''}`
                                                : (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faUser, size: 14, color: "white" }) }) }), (0, jsx_runtime_1.jsxs)(VStack_1.default, { space: 11, 
                                        // width={chatMsg.message.length > 40 ? "65%" : null}
                                        maxWidth: "100%", borderBottomLeftRadius: 20, borderTopRightRadius: 20, borderTopLeftRadius: 20, 
                                        // mr={isTabOrDesktopDevice ? 0 : 4}
                                        flex: 1, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: "white", fontSize: 18, fontWeight: 500, lineHeight: "normal", children: "You" }), chatMsg.message !== '' && ((0, jsx_runtime_1.jsx)(ChatText_1.default, { message: chatMsg })), (chatMsg.filesSource || chatMsg.mediaUrls.length > 0) && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                                    gap: 6,
                                                    paddingTop: 8,
                                                    paddingLeft: 16,
                                                }, children: (chatMsg.filesSource ?? chatMsg.mediaUrls)
                                                    .reduce((mediasUrl, mediaSource) => {
                                                    const name = (typeof mediaSource === 'string' ? mediaSource : mediaSource.name);
                                                    const url = (typeof mediaSource === 'string' ? mediaSource : mediaSource.url);
                                                    if ((0, chat_1.checkIsFile)(name)) {
                                                        return [
                                                            ...mediasUrl,
                                                            {
                                                                type: 'file',
                                                                url,
                                                                ...(typeof mediaSource !== 'string' && { name }),
                                                            },
                                                        ];
                                                    }
                                                    ;
                                                    const lastMedia = mediasUrl[mediasUrl.length - 1];
                                                    if (lastMedia && lastMedia.type === 'image' && !Array.isArray(lastMedia.url)) {
                                                        return [
                                                            ...mediasUrl.slice(0, -1),
                                                            { type: 'image', url: [lastMedia.url, url] }
                                                        ];
                                                    }
                                                    return [...mediasUrl, { type: 'image', url }];
                                                }, []).map((renderMedia) => (renderMedia.type === 'file' && ((0, jsx_runtime_1.jsx)(ChatFile_1.default, { name: renderMedia.name ?? (0, utils_1.getFileUrlName)(renderMedia.url) ?? '', source: renderMedia.url }, renderMedia.url)) || typeof renderMedia.url === 'string' && ((0, jsx_runtime_1.jsx)(UserImage, { source: renderMedia.url }, renderMedia.url)) || ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                                        gap: 6,
                                                        flexDirection: 'row',
                                                    }, children: [(0, jsx_runtime_1.jsx)(UserImage, { source: renderMedia.url[0] }, renderMedia.url[0]), (0, jsx_runtime_1.jsx)(UserImage, { source: renderMedia.url[1] }, renderMedia.url[1])] })))) }))] })] }), chatMsg.message !== "" && ((0, jsx_runtime_1.jsx)(AppTooltip_1.default, { label: 'Copy', children: (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: () => handleCopyText(chatMsg.message), style: {
                                        backgroundColor: colors_1.Colors.DARK_500,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        alignSelf: 'flex-start',
                                        marginTop: 6,
                                        marginLeft: 44,
                                        padding: 5,
                                        borderRadius: 12,
                                    }, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faClipboard, size: 14, color: "white" }) }) }))] })), chatMsg.sender === "tutor" && ((0, jsx_runtime_1.jsx)(VStack_1.default, { pt: 4, pb: 2, children: (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.DARK_200, textAlign: "center", fontSize: (0, theme_1.normalize)(13), children: chatMsg.message === "ON"
                                ? "You Switched to Tutor Mode"
                                : `You Exited Tutor Mode` }) })), chatMsg.sender === "mood_changer" && ((0, jsx_runtime_1.jsx)(VStack_1.default, { pt: 4, pb: 2, children: (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.DARK_200, textAlign: "center", fontSize: (0, theme_1.normalize)(13), children: chatMsg.message === "UNSET"
                                ? "You Cleared the Mood"
                                : `You Switched to ${chatMsg?.message} Mood` }) })), chatMsg.sender === "assistant" && ((0, jsx_runtime_1.jsx)(VoiceMessage_1.default, { activeMessage: activeMessage, setActiveMessage: setActiveMessage, index: index + 1, message: chatMsg.message, isPlaying: isPlaying, setIsPlaying: setIsPlaying, chatMessage: chatMsg, setIsSheetOpen: setIsSheetOpen, isSheetOpen: isSheetOpen, scrollRef: scrollRef, scrollToMessage: scrollToMessage, getParentIndex: getMessageIndex, 
                        // autoPlay={
                        //   autoPlay && newMessageControl.current && index + 1 === messagesRef.current?.length
                        // }
                        handleReadAloud: () => handleReadAloud(chatMsg) }))] }, `${chatMsg.conversationId}-${chatMsg?.id}-${index}-${chatMsg.updatedAt}-msg`) }));
    }, [
        isImageLoading,
        autoPlay,
        chatAction,
        conversation,
        userFirstName,
        userLastName,
        msgsMemo,
        UserImage,
    ]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isAudioPlaying && audioMessage && ((0, jsx_runtime_1.jsx)(ReadLoud_1.default, { source: audioMessage, onClose: handleClosePlayer })), (0, jsx_runtime_1.jsx)(react_native_1.FlatList, { data: msgsMemo, renderItem: renderItem, ref: scrollRef, keyExtractor: (item, index) => `${item.id}-${item.conversationId}-${index}-${item.createdAt}`, onScroll: ({ nativeEvent: { contentOffset, contentSize, layoutMeasurement } }) => {
                    if (contentOffset.y >= lastScrollPosition.current) {
                        if (contentOffset.y >= contentSize.height - layoutMeasurement.height) {
                            setIsUserScrolling(false);
                        }
                    }
                    else {
                        setIsUserScrolling(true);
                    }
                    lastScrollPosition.current = contentOffset.y;
                }, onScrollToIndexFailed: ({ index }) => {
                    scrollRef.current?.scrollToEnd();
                    scrollRef.current?.scrollToIndex({ index });
                }, onContentSizeChange: (_w, h) => {
                    if (!isUserScrolling
                        && !isPlaying
                        && chatAction !== "regenerate") {
                        scrollRef?.current?.scrollToOffset({
                            offset: h - 20,
                            animated: true,
                        });
                    }
                }, keyboardShouldPersistTaps: "handled", keyboardDismissMode: "interactive", automaticallyAdjustKeyboardInsets: true, automaticallyAdjustContentInsets: true, contentInsetAdjustmentBehavior: "never", ListHeaderComponent: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isMsgBox && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !(isWebDevice && isMobileScreen) && ((0, jsx_runtime_1.jsx)(native_base_1.Box, { marginTop: 4, marginBottom: 2, children: (0, jsx_runtime_1.jsx)(MessageWarn_1.default, {}) })) })), documentJson && ((0, jsx_runtime_1.jsx)(VoiceMessage_1.default, { activeMessage: activeMessage, setActiveMessage: setActiveMessage, index: 0, message: (0, document_2.getMarkdownBlock)('summaryResponse' in documentJson
                                ? documentJson.summaryResponse
                                : documentJson.message, 'Dive Deeper') ?? '', diveDeeper: true, isPlaying: isPlaying, setIsPlaying: setIsPlaying, 
                            // chatMessage={chatMsg}
                            setIsSheetOpen: setIsSheetOpen, isSheetOpen: isSheetOpen, scrollRef: scrollRef, scrollToMessage: scrollToMessage, getParentIndex: getMessageIndex }))] })), ListFooterComponent: ((0, jsx_runtime_1.jsx)(StreamBox, {})), contentContainerStyle: {
                    width: "100%",
                    paddingHorizontal: 12,
                    paddingBottom: (insets?.bottom || 20) + 6,
                    gap: 24,
                }, style: { marginTop: isWebDevice && isMobileScreen ? 8 : undefined } }), (0, jsx_runtime_1.jsx)(yet_another_react_lightbox_1.default, { slides: messageImages.map((src) => ({ src })), index: viewingImageIndex, open: isViewingImage, close: () => setIsViewingImage(false), carousel: { finite: true }, thumbnails: { imageFit: 'cover' }, zoom: { maxZoomPixelRatio: 10 }, render: {
                    buttonPrev: messageImages.length <= 1 ? () => null : undefined,
                    buttonNext: messageImages.length <= 1 ? () => null : undefined,
                }, plugins: [counter_1.default, fullscreen_1.default, thumbnails_1.default, zoom_1.default] })] }));
};
exports.default = (0, react_1.memo)(ChatMessages);
